<template>
  <section class="batch-box">
    <p class="batch-step-title">第一步：导出模板或下载模板</p>
    <div class="batch-step-box">
      <div>
        <p>
          方法一：导出模板（从线路档案中导出线路资料作为模板，再修改车辆信息）
          <span class="primary cur" @click="toLineList">去导出模板</span>
        </p>
      </div>
      <div>
        <p>方法二：下载模板（下载模板后再填写线路及车辆信息）</p>
        <p class="batch-content" v-for="(item, index) in doanloadTempList" :key="index">
          <span class="primary cur batch-label" @click="downloadTemp(item.url)">{{ item.name }}</span>
          <span class="batch-value">
            {{ item.desc }}
            <span class="error">{{ item.modeName }}</span> 的订单
          </span>
        </p>
        <div class="new-batch-content" v-for="(item, index) in batchDownloadList" :key="index">
          <span class="primary cur new-batch-label" @click="downloadTemp(item.url)">{{ item.name }}</span>
          <div class="descBox">
            <span class="batch-value">{{ item.desc1 }}</span>
            <span class="batch-value">{{ item.desc2 }}</span>
          </div>
        </div>
      </div>
    </div>
    <p class="batch-step-title">第二步：导入文件</p>
    <div class="batch-step-box">
      <qx-permpisions permpisions>
        <ImportBtn title="导入" btnName="报账模式和承包模式导入" bizCodes="imp300010" type="getImportTempFile"/>
        <ImportBtn class="orderImpBtn"
                   title="订单模式固定线路导入" btnName="订单模式固定线路导入"
                   bizCodes="imp1000129"
                   type="getImportTempFile"
                   fileType="package"
                   tipDesc1="2、因订单模式录入包含支出费用信息，如需上传费用附件请将文件和附件统一压缩后上传，若不同时上传，后期不可批量导入附件信息，仅可在司机端逐个提交；"
                   tipDesc2="3、压缩包要求：请上传zip、rar文件，其中包含Excel文件+附件文件夹，若无附件则删除附件文件夹即可；"
                   tipDesc3="4、附件文件夹及费用附件的命名方式：文件夹根据订单在Excel表格中的序号值进行命名，附件图片仅可填写油费、路桥费、维修保养、其他费用，若油费存在两张图片附件，则命名为油费1、油费；2、其他同理。"
        />
        <ImportBtn class="orderImpBtn"
                   title="订单模式临时线路导入" btnName="订单模式临时线路导入"
                   bizCodes="imp1000130"
                   type="getImportTempFile"
                   fileType="package"
                   tipDesc1="2、因订单模式录入包含支出费用信息，如需上传费用附件请将文件和附件统一压缩后上传，若不同时上传，后期不可批量导入附件信息，仅可在司机端逐个提交；"
                   tipDesc2="3、压缩包要求：请上传zip、rar文件，其中包含Excel文件+附件文件夹，若无附件则删除附件文件夹即可；"
                   tipDesc3="4、附件文件夹及费用附件的命名方式：文件夹根据订单在Excel表格中的序号值进行命名，附件图片仅可填写油费、路桥费、维修保养、其他费用，若油费存在两张图片附件，则命名为油费1、油费；2、其他同理。"
        />
        <el-popover placement="right" width="150" trigger="hover" style="text-indent: 1em">
          <div>订单模式导入操作步骤</div>
          <i
              class="el-icon-question cur warning"
              @click="showIntroDialog"
              slot="reference"
          />
        </el-popover>
        <IntroDialog ref="introDialog" />
      </qx-permpisions>
      <!-- <span class="primary cur" @click="uploadFile">上传excel文件</span> -->
    </div>
  </section>
</template>

<script>
import ImportBtn from 'components/importBtn';
import IntroDialog from './introDialog';
export default {
  components: {
    ImportBtn,
    IntroDialog,
  },
  data () {
    return {
      doanloadTempList: [
        { name: '自有车-智能模式订单 模板', desc: '用于批量导入自有车的成本模式为', modeName: '智能模式', url: '/file/订单导入(智能模式)模板.xlsx' },
        { name: '自有车-报账模式订单 模板', desc: '用于批量导入自有车的成本模式为', modeName: '报账模式', url: '/file/订单导入(报账模式)模板.xlsx' },
        { name: '自有车-承包模式订单 模板', desc: '用于批量导入自有车的成本模式为', modeName: '承包模式', url: '/file/订单导入(承包模式)模板.xlsx' },
        { name: '非自有车订单 模板', desc: '用于批量导入', modeName: '外调车、招商车、挂靠车', url: '/file/订单导入(外调车)模板.xlsx' },
      ],
      batchDownloadList: [
        { name: '自有车-订单模式临时线路订单 模板',
          desc1: '1、用于批量导入自有车的成本模式为 订单模式且临时线路的订单，临时线路无需维护客户线路信息',
          desc2: '2、下载文件为zip文件，请解压后，按照Excel文件+附件文件夹信息填写完成后，进行压缩后统一上传',
          modeName: '', url: '/file/订单导入(订单模式-临时线路)模板.zip' },
        { name: '自有车-订单模式固定线路订单 模板',
          desc1: '1、用于批量导入自有车的成本模式为 订单模式+固定线路的订单，固定线路需维护客户线路信息',
          desc2: '2、下载文件为zip文件，请解压后，按照Excel文件+附件文件夹信息填写完成后，进行压缩后统一上传',
          modeName: '', url: '/file/订单导入(订单模式-固定线路)模板.zip' },
      ],
    };
  },
  methods: {
    toLineList () {
      this.jump({
        label: '线路档案',
        url: '/manage/archives/customer/line',
      });
    },
    downloadTemp (url) {
      window.open(url);
    },
    showIntroDialog () {
      this.$refs.introDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.batch-box {
  background: #ffffff;
  padding: 10px;
  line-height: 2;
  .batch-step-box {
    text-indent: 3em;
    .batch-content {
      display: flex;
      .batch-label {
        width: 355px;
        text-indent: 7em;
      }
    }
    .new-batch-content {
      display: flex;
      .new-batch-label{
        width:400px;
        text-indent: 7em;
      }
      .descBox{
        display: flex;
        text-indent: 0em;
        flex-direction: column;
      }
    }
    .orderImpBtn{
      margin-left: 20px;
    }
  }
}
</style>
